module.exports = __webpack_public_path__ + "img/2015.02-CNAS GLP.c8f9a17a.jpg";